import React, { createContext } from 'react';
import {
  oneOfType, arrayOf, node, string, func, shape
} from 'prop-types';
import { useCarPicker } from '../hooks/useCarPicker';

const initialState = {
  appliedDimensions: [],
  dynamicOptionTypes: [],
  filter: {},
  fitmentItems: [],
  fitmentOptions: {
    YEAR: [],
    MAKE: [],
    MODEL: []
  },
  fitmentVariables: {},
  navParam: '',
  onCarSelectionChange: () => {},
  onCarPickerUrlRedirect: undefined,
  optionTypes: [],
  pageType: '',
  pipFitmentRequest: () => {},
  selectedOption: {
    YEAR: { id: '', displayValue: 'Pick Your Year', option: 'year' },
    MAKE: { id: '', displayValue: 'Pick Your Make', option: 'make' },
    MODEL: { id: '', displayValue: 'Pick Your Model', option: 'model' }
  },
  triggerFitmentItemsCallback: false,
  redirectUrl: '',
  pipRedirectUrlLabel: ''
};

export const carPickerReducer = (state = initialState, { action, value }) => {
  switch (action) {
  case 'SET_VARIABLES':
    return { ...state, fitmentVariables: value };
  case 'SET_OPTIONS':
    return { ...state, fitmentOptions: value };
  case 'SET_SELECTED_OPTIONS':
    return { ...state, selectedOption: value };
  case 'SET_OPTION_TYPES':
    return { ...state, optionTypes: value };
  case 'SET_FILTER':
    return { ...state, filter: value };
  case 'SET_DYNAMIC_OPTION_TYPES':
    return { ...state, dynamicOptionTypes: value };
  case 'SET_FITMENT_ITEMS':
    return { ...state, fitmentItems: value };
  case 'TRIGGER_FITMENT_ITEMS_CALLBACK':
    return { ...state, triggerFitmentItemsCallback: value };
  case 'SET_REDIRECT_URL':
    return { ...state, redirectUrl: value };
  default:
    return state;
  }
};

const CarPickerContext = createContext();
CarPickerContext.displayName = 'CarPickerContext';

export const CarPickerContextProvider = ({
  children, navParam, pageType, onCarSelectionChange, onCarPickerUrlRedirect, appliedDimensions, pipRedirectUrlLabel
}) => {
  const [state, dispatch, getStaticDropDownOptions, errorState, pipFitmentRequest] = useCarPicker({
    carPickerReducer, initialState, navParam, pageType, appliedDimensions
  });

  if (errorState) {
    return null;
  }

  return (
    <CarPickerContext.Provider value={{
      ...state,
      dispatch,
      getStaticDropDownOptions,
      pipFitmentRequest,
      pipRedirectUrlLabel,
      onCarSelectionChange,
      onCarPickerUrlRedirect
    }}
    >
      {children}
    </CarPickerContext.Provider>
  );
};

CarPickerContextProvider.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  navParam: string.isRequired,
  pageType: string,
  onCarSelectionChange: func,
  onCarPickerUrlRedirect: func,
  appliedDimensions: arrayOf(shape({})),
  pipRedirectUrlLabel: string
};

CarPickerContextProvider.defaultProps = {
  pageType: 'browse',
  onCarSelectionChange: () => {},
  onCarPickerUrlRedirect: undefined,
  appliedDimensions: [],
  pipRedirectUrlLabel: ''
};

export default CarPickerContext;
